export const FUNDS_REPORT_UNIT_TYPES = ["Halqa", "Tanzeem"];

export const isFundsReportUnitType = (unitType) =>
  FUNDS_REPORT_UNIT_TYPES.some(
    (allowed) =>
      typeof unitType === "string" &&
      allowed.toLowerCase() === unitType.toLowerCase()
  );
